import React from 'react'
import styles from '../../styles/company.module.css';
import SectionTitle from '../common/SectionTitle';
import { IMAGEPATH } from '../../constants/imagePath';
import { ICONPATH } from '../../constants/iconPath';
import { KR } from '../../constants/localizations';

export default function CompanyDirectionSection() {
    return (
        <div className={styles.direction}>
            <SectionTitle title={KR.label_company_direction} titleEng={KR.label_company_direction_address_eng} />
            <div className={styles.content}>
                <div className={styles.map}>
                    <img src={IMAGEPATH.map} srcSet={IMAGEPATH.mapWebp} alt="ar247_company_map" loading="lazy" />
                </div>
                <div>
                    <div className={styles.contactW}>
                        <div className={styles.contact}>
                            <div>
                                <img src={ICONPATH.home} alt="icon_house" />
                            </div>
                            <span>{KR.label_company_direction_address}</span>
                            <span>{KR.label_company_direction_address_eng}</span>
                        </div>
                        <div>{KR.label_company_direction_address_detail}</div>
                    </div>
                    <div className={styles.contactW}>
                        <div className={styles.contact}>
                            <div>
                                <img src={ICONPATH.print} alt="icon_fax" />
                            </div>
                            <span>{KR.label_company_direction_fax}</span>
                            <span>{KR.label_company_direction_fax_eng}</span>
                        </div>
                        <div>{KR.label_company_direction_fax_detail}</div>
                    </div>
                    <div className={styles.contactW}>
                        <div className={styles.contact}>
                            <div>
                                <img src={ICONPATH.mail} alt="icon_mail" />
                            </div>
                            <span>{KR.label_company_direction_mail}</span>
                            <span>{KR.label_company_direction_mail_eng}</span>
                        </div>
                        <div>{KR.label_company_direction_mail_detail}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}
